// extracted by mini-css-extract-plugin
module.exports = {"mainGetStarted":"CTA-module--mainGetStarted--O7EIz","gsImgBox":"CTA-module--gsImgBox--J94fH","gsCopy":"CTA-module--gsCopy--1-p-z","getStarted":"CTA-module--getStarted--XRaUP"};